module.exports = __webpack_public_path__ + "e315120b2a16e24f2e9e09cacc60df53.svg";